/**
 * Upload a file into an Airtable attachment field via the proxy.
 *
 * Airtable's uploadAttachment endpoint lives on content.airtable.com;
 * the proxy routes any "/content"-prefixed path to that host.
 */
import { getProxyToken } from "../proxyToken";

const AIRTABLE_APP = "apprWesJGBmsmfsWx";
const PROXY_ENDPOINT = process.env.REACT_APP_AIRTABLE_PROXY_URL
  || "https://airtableproxy-psmwtza64a-uc.a.run.app";

// Airtable rejects uploadAttachment payloads over 5MB.
export const MAX_UPLOAD_BYTES = 5 * 1024 * 1024;

const fileToBase64 = (file: File) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result).split(",")[1] || "");
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });

export const uploadAttachment = async (
  recordId: string,
  fieldId: string,
  file: File
): Promise<any> => {
  const token = getProxyToken();
  if (!token) throw new Error("Not authenticated");

  const base64 = await fileToBase64(file);
  const res = await fetch(
    `${PROXY_ENDPOINT}/content/v0/${AIRTABLE_APP}/${recordId}/${fieldId}/uploadAttachment`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        contentType: file.type,
        file: base64,
        filename: file.name,
      }),
    }
  );
  if (!res.ok) throw new Error(`Upload failed (${res.status})`);
  return res.json();
};
